import { combineReducers } from "redux";
import sidebarCollapseReducer from "./sidebarCollapseReducer"
import sidebarMenuReducer from "./sidebarMenuReducer"
const reducer = combineReducers({
  collapse: sidebarCollapseReducer,
  menu: sidebarMenuReducer
})

export default reducer;

